<template>
  <div class="d-flex">
    <div class="avatar mr-3">
      <img :src="avatar" class="mt-1" />
    </div>
    <div class="d-flex flex-column flex-grow-1">
      <template v-if="!editMode">
        <div style="font-size: 14px;">
          <strong class="mr-2">{{ displayName }}</strong>
          <small style="color: #bbb;">{{ date }}</small>
        </div>
        <span class="comment-content" v-html-sanitize="comment"></span>
      </template>
      <smart-text-input
        v-else
        v-model="internalComment"
        v-on:update:mentions="updateMentions"
        :mentions="mentions"
        :maxLength="5000"
        :showListOptions="false"
        backgroundColor="#FFF"
        @submit="e => $emit('update', e)"
        @cancel="cancelEdition"
      />
    </div>
    <div
      v-if="actions.length && !editMode"
      v-html="actionsHtml"
      class="ml-auto"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import avatarServer from "../server/avatar";
import SmartTextInput from "../components/controls/SmartTextInput.vue";
const defaultAvatar = require("../assets/avatar-example.png");

export default {
  name: "UserComment",
  components: { SmartTextInput },
  props: {
    user: {
      type: Object
    },
    comment: {
      type: String,
      required: true
    },
    mentions: {
      type: Array,
      default: () => []
    },
    date: {
      type: String
    },
    editMode: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      avatar: null,
      internalComment: null
    };
  },
  async mounted() {
    this.hookDropdownButtons();
    this.internalComment = this.comment;

    if (this.user) {
      this.avatar = this.user.avatarId
        ? await avatarServer.downloadUrl(this.user.avatarId)
        : defaultAvatar;
    } else {
      this.avatar = this.currentUser.avatar ?? defaultAvatar;
    }
  },
  methods: {
    editComment(e) {
      this.$emit("update", e);
    },
    cancelEdition() {
      this.internalComment = this.comment;
      this.$emit("cancel");
    },
    updateMentions(e) {
      this.$emit("update:mentions", e);
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    displayName() {
      return this.user
        ? this.formatUser(this.user)
        : this.formatUser(this.currentUser);
    },
    displayDate() {
      return "";
    },
    actionsHtml() {
      return this.actions.length
        ? this.createDropdownButton({
            items: this.actions
          })
        : "";
    }
  },
  watch: {
    comment(newValue) {
      this.internalComment = newValue;
    },
    actionsHtml() {
      if (this.actions.length) {
        this.hookDropdownButtons();
      }
    }
  }
};
</script>

<style scoped>
.avatar img {
  width: 40px;
  height: auto;
  border-radius: 50%;
}

.comment-content {
  font-size: 13px;
}
.comment-content p:last-of-type {
  margin-bottom: 0;
}
</style>
